// extracted by mini-css-extract-plugin
export default {"linkWrapper":"LinkView_linkWrapper__YRt4D","link":"LinkView_link__MheGi","linkText":"LinkView_linkText__HmCQT","copyIcon":"LinkView_copyIcon__+QdnF"};